module.exports = __webpack_public_path__ + "static/media/armour.11e492ad.jpg";